import React from "react";
import BugReportIcon from "@mui/icons-material/BugReport";
import {observer} from "mobx-react-lite";
import {useStores} from "../../../../../stores";
import {Box, Button} from "@mui/material";
import {devopsClearCategorizationTableSettings} from "./settings/CategorizationTableSettings.ts";
import type {DeserializedGridColDef} from "../../../../../components/muix-data-grid/MuiXColumnDefinitions.ts";
import type {CustomReviewColumnTypes} from "./columns/ColumnTypes";
import {devopsClearCategorizationTableColumnSettings} from "./settings/CategorizationColumnSettings.ts";
import {environment} from "../../../../../env.ts";

type C = DeserializedGridColDef<CustomReviewColumnTypes>;
type Props = {
    columns: C[]
};
export const CategorizationTableDebug: React.FC<Props> = observer(({columns}) => {
    const {authStore, bagStore, categorizationReviewStore} = useStores()
    const tableController = categorizationReviewStore.reviewPageController.reviewPageTableController;
    const filterController = categorizationReviewStore.reviewPageController.reviewPageFilterController;
    const filterModel = filterController.gridFilterModel;

    if (!(environment.isTestReviewPage && authStore.isMithraStaff)) {
        return null;
    }

    return <Box component="div" sx={{maxWidth: '1700px', overflow: 'auto'}}>
        <div>
            <b>bagStore</b>: {JSON.stringify(bagStore.categorizationColumns.map(c => `${c.table_name}.${c.column_name}`))}<br/>
            <b>cols</b>: {JSON.stringify(columns.map(c => c.field))}<br/>
        </div>
        <div>
            <b>rowGroupingModel</b>: {JSON.stringify(tableController.rowGroupingModel)}<br/>
        </div>
        <div>
            <b>visibilityModel</b>: {JSON.stringify(tableController.visibilityModel)}
        </div>
        <div>
            <b>pinnedColumns</b>: {JSON.stringify(tableController.pinnedColumns)}
        </div>
        <div>
            <b>gridFilterModel</b> items[{filterModel.items.length}]:
            {' ' + filterModel.items.map(i => `${i.field} ${i.operator} ${JSON.stringify(i.value)} (${i.id})`).join(' | ')}
            <br/>
            {/*{JSON.stringify(filterModel)}*/}
        </div>
        <div>
            <b>API gridFilterModel</b> items[{filterController.apiGridFilterModel.items.length}]:
            {' ' + filterController.apiGridFilterModel.items.map(i => `${i.field} ${i.operator} ${JSON.stringify(i.value)} (${i.id})`).join(' | ')}
            <br/>
            {/*{JSON.stringify(filterController.apiGridFilterModel)}*/}
        </div>
        <div>
            <b>_muiXGridFilterModel</b> items[{filterController._muiXGridFilterModel.items.length}]:
            {' ' + filterController._muiXGridFilterModel.items.map(i => `${i.field} ${i.operator} ${JSON.stringify(i.value)} (${i.id})`).join(' | ')}
        </div>
        <div>
            <b>pipe</b>:
            {' ' + categorizationReviewStore.reviewPageController.reviewApi.nInPipe}
        </div>
        <Button
            startIcon={<BugReportIcon/>}
            onClick={() => categorizationReviewStore.setViewOnly(!categorizationReviewStore.viewOnly)}>
            viewOnly: {'' + categorizationReviewStore.viewOnly}
        </Button>
        <Button
            startIcon={<BugReportIcon/>}
            onClick={() => {
                devopsClearCategorizationTableColumnSettings();
                devopsClearCategorizationTableSettings();
                window.location.reload();
            }}
        >
            clear settings
        </Button>
    </Box>
})